'use client';

import { c as _c } from "react/compiler-runtime";
import { SignInButton, useAuth } from '@clerk/nextjs';
import { Suspense } from 'react';
import { Icon } from '@/components/icon';
import { Text } from '@/components/text';
import { OnboardingExitButton } from './onboarding-exit.client';
function HeaderAuth() {
  const $ = _c(2);
  const {
    isSignedIn
  } = useAuth();
  if (isSignedIn) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="w-32" />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="leading-none"><Text variant="body-sm" className="text-sm">Already have an account?{" "}<SignInButton><button type="button" className="underline">Login</button></SignInButton></Text></div>;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
interface OnboardingHeaderProps {
  logo: React.ReactNode;
}
export function OnboardingHeader(t0) {
  const $ = _c(6);
  const {
    logo
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <OnboardingExitButton className="flex h-auto items-center gap-2 p-0 text-white hover:text-white"><Icon name="arrow" className="max-w-4" /><Text variant="body-sm" className="relative top-px leading-none">Exit</Text></OnboardingExitButton>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== logo) {
    t2 = <OnboardingExitButton aria-label="Home" className="absolute left-1/2 flex -translate-x-1/2 items-center gap-2">{logo}</OnboardingExitButton>;
    $[1] = logo;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Suspense fallback={<div className="w-32" />}><HeaderAuth /></Suspense>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <header className="relative z-10 flex shrink-0 items-center justify-between p-4 text-sm lg:p-6">{t1}{t2}{t3}</header>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}